<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_7"></a>
<p class="toc">Contents</p>
<table cellpadding="2" cellspacing="0" style="margin-top: 5em;" width="100%">
<colgroup><col width="5%"/>
<col width="95%"/>
</colgroup><tbody><tr>
<td valign="top">  <a href="#/10_Chapter01#ch01"><i>1</i></a></td>
<td valign="top"><a href="#/10_Chapter01#ch01"><i>Waving</i></a></td>
</tr>
<tr>
<td valign="top">  <a href="#/11_Chapter02#ch02"><i>2</i></a></td>
<td valign="top"><a href="#/11_Chapter02#ch02"><i>Performance</i></a></td>
</tr>
<tr>
<td valign="top">  <span href="#/12_Chapter03#ch03" title="Link target outside of Sample"><i>3</i></span></td>
<td valign="top"><span href="#/12_Chapter03#ch03" title="Link target outside of Sample"><i>On the sidelines</i></span></td>
</tr>
<tr>
<td valign="top">  <span href="#/13_Chapter04#ch04" title="Link target outside of Sample"><i>4</i></span></td>
<td valign="top"><span href="#/13_Chapter04#ch04" title="Link target outside of Sample"><i>Death of a spinster</i></span></td>
</tr>
<tr>
<td valign="top">  <span href="#/14_Chapter05#ch05" title="Link target outside of Sample"><i>5</i></span></td>
<td valign="top"><span href="#/14_Chapter05#ch05" title="Link target outside of Sample"><i>The prisoner</i></span></td>
</tr>
<tr>
<td valign="top">  <span href="#/15_Chapter06#ch06" title="Link target outside of Sample"><i>6</i></span></td>
<td valign="top"><span href="#/15_Chapter06#ch06" title="Link target outside of Sample"><i>Homecoming</i></span></td>
</tr>
<tr>
<td valign="top">  <span href="#/16_Chapter07#ch07" title="Link target outside of Sample"><i>7</i></span></td>
<td valign="top"><span href="#/16_Chapter07#ch07" title="Link target outside of Sample"><i>At the bar</i></span></td>
</tr>
<tr>
<td valign="top">  <span href="#/17_Chapter08#ch08" title="Link target outside of Sample"><i>8</i></span></td>
<td valign="top"><span href="#/17_Chapter08#ch08" title="Link target outside of Sample"><i>In the steps of Spartacus</i></span></td>
</tr>
<tr>
<td valign="top">  <span href="#/18_Chapter09#ch09" title="Link target outside of Sample"><i>9</i></span></td>
<td valign="top"><span href="#/18_Chapter09#ch09" title="Link target outside of Sample"><i>Sentences</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/19_Chapter10#ch10" title="Link target outside of Sample"><i>10</i></span></td>
<td valign="top"><span href="#/19_Chapter10#ch10" title="Link target outside of Sample"><i>Getting along</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/20_Chapter11#ch11" title="Link target outside of Sample"><i>11</i></span></td>
<td valign="top"><span href="#/20_Chapter11#ch11" title="Link target outside of Sample"><i>Mick’s day</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/21_Chapter12#ch12" title="Link target outside of Sample"><i>12</i></span></td>
<td valign="top"><span href="#/21_Chapter12#ch12" title="Link target outside of Sample"><i>Tig</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/22_Chapter13#ch13" title="Link target outside of Sample"><i>13</i></span></td>
<td valign="top"><span href="#/22_Chapter13#ch13" title="Link target outside of Sample"><i>Beached</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/23_Chapter14#ch14" title="Link target outside of Sample"><i>14</i></span></td>
<td valign="top"><span href="#/23_Chapter14#ch14" title="Link target outside of Sample"><i>How many miles to Babylon?</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/24_Chapter15#ch15" title="Link target outside of Sample"><i>15</i></span></td>
<td valign="top"><span href="#/24_Chapter15#ch15" title="Link target outside of Sample"><i>Callers</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/25_Chapter16#ch16" title="Link target outside of Sample"><i>16</i></span></td>
<td valign="top"><span href="#/25_Chapter16#ch16" title="Link target outside of Sample"><i>End game</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/26_Chapter17#ch17" title="Link target outside of Sample"><i>17</i></span></td>
<td valign="top"><span href="#/26_Chapter17#ch17" title="Link target outside of Sample"><i>Hullo again</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/27_Chapter18#ch18" title="Link target outside of Sample"><i>18</i></span></td>
<td valign="top"><span href="#/27_Chapter18#ch18" title="Link target outside of Sample"><i>Holing out</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/28_Chapter19#ch19" title="Link target outside of Sample"><i>19</i></span></td>
<td valign="top"><span href="#/28_Chapter19#ch19" title="Link target outside of Sample"><i>Deathwatch beetle</i></span></td>
</tr>
<tr>
<td valign="top"><span href="#/29_Chapter20#ch20" title="Link target outside of Sample"><i>20</i></span></td>
<td valign="top"><span href="#/29_Chapter20#ch20" title="Link target outside of Sample"><i>Dreaming</i></span></td>
</tr>
</tbody></table>
<a id="page_8"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Toc.vue?c63405d4